<template>
  <ModalBase @close-modal="() => closePolicyModal()">
    <div class="modalLayout">
      <div class="modalContainer">
        <div class="modalIframe">
          <InlineFrameModal>
            <iframe
              src="https://s3-ap-northeast-1.amazonaws.com/files.xmd.io/public/rule/privacy_policy.html"
              width="100%"
              frameborder="0"
            ></iframe>
          </InlineFrameModal>
        </div>
      </div>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import ModalBase from '../genenral/ModalBase.vue'
import { useStore } from 'vuex'
import InlineFrameModal from '@/components/block/InlineFrameModal.vue'

export default defineComponent({
  name: 'ModalHpcrPolicy',

  components: {
    ModalBase,
    InlineFrameModal
  },

  props: {
    closeModal: {
      type: Function as PropType<() => void>,
      required: true
    }
  },

  setup(props) {
    const store = useStore()

    const closePolicyModal = () => {
      store.commit('unFixBody')
      props.closeModal()
    }

    return {
      closePolicyModal
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

::v-deep .modal {
  height: calc(100% + 40px);
  width: 100%;
  max-width: 712px;
  margin-top: 20px;
  padding-right: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mixins.media() {
    height: 100%;
    padding: 40px;
  }
}
.modalLayout {
  width: 100%;
  height: 100%;
  padding: 0 36px 72px;
  overflow-y: auto;
  @include mixins.media() {
    padding: 0;
  }
}
.modalContainer {
  height: calc(100%);
}
.modalIframe {
  height: 100%;
}
</style>
